import styles from './admin-future-renewals.module.scss';
import { Box, Container, CreateHeaders, HeaderSizeEnum, booleanHeader, currencyHeader, dateHeader, textHeader } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import FullTable from '../../full-table/full-table';
import { addYears } from 'date-fns';
import { useTranslation } from 'react-i18next';


/* eslint-disable-next-line */
export interface FutureRenewalsProps { }

export function FutureRenewals(props: FutureRenewalsProps) {

  const { t } = useTranslation();

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.futureRenewals")} subtitle={`(${t("standard.admin")})`} />
            <FullTable
              initialStartDate={new Date()}
              initialEndDate={new Date(addYears(new Date(), 3))}
              supportFutureDates={true}
              url={`reports/future-renewal`}
              tableConfigName='futureRenewalsGrid'
              headers={CreateHeaders([
                textHeader("companyNumber", "Firmanr.", HeaderSizeEnum.MEDIUM),
                textHeader("companyName", "Firma", HeaderSizeEnum.EXTRA_LARGE),
                textHeader("productGroupName", "Gruppe", HeaderSizeEnum.LARGE),
                textHeader("productName", "Produktnavn", HeaderSizeEnum.LARGE),
                textHeader("recurringItem", "Gjentagende vare", HeaderSizeEnum.EXTRA_LARGE),
                textHeader("licenseType", "Type", HeaderSizeEnum.MEDIUM),
                textHeader("invoiceInterval", "Kontraktslengde", HeaderSizeEnum.LARGE, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                textHeader("quantity", "Antall", HeaderSizeEnum.MEDIUM, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                textHeader("seats", "Seter", HeaderSizeEnum.MEDIUM, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                currencyHeader("oneTimeDiscount", "Engangsrabatt", HeaderSizeEnum.LARGE, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                textHeader("recurringDiscountPercent", "Rabatt", HeaderSizeEnum.MEDIUM, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                currencyHeader("nextInvoiceCost", "Neste faktura", HeaderSizeEnum.LARGE, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                currencyHeader("acv", "ACV", HeaderSizeEnum.LARGE, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                currencyHeader("residualValue", "Restverdi", HeaderSizeEnum.LARGE, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                currencyHeader("recidualValueAtYearStart", "Restverdi ved start av nytt år", HeaderSizeEnum.MEDIUM, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                textHeader("invoiceMonth", "Måned", HeaderSizeEnum.SMALL, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                textHeader("invoiceYear", "År", HeaderSizeEnum.SMALL),
                dateHeader("nextInvoicingDate", "Neste fakturadato"),
                booleanHeader("isAcademic", "Akademisk"),
                booleanHeader("isTerminatedByNextRenewal", "Skal ikke fornyes")
                //booleanHeader("isNewSale", "Nytt salg")
              ])}
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default FutureRenewals;